import React, { PureComponent } from 'react';

import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';

class EnhancedTableHead extends PureComponent {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { id, order, orderBy } = this.props;

        return (
            <TableHead>
                <TableRow className="tableRow tableHeader">
                {this.props.headerRows.map(row => {
                    return (
                        <TableCell
                            key={row.id}
                            className={row.className}
                            padding={row.disablePadding ? 'none' : 'default'}
                            sortDirection={orderBy === row.id ? order : false}>
                            { row.notSortable ? row.label :
                                <Tooltip
                                    title={`Ordenar por ${row.label}`}
                                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={200}>
                                    <span><TableSortLabel
                                        id={id + "_" + row.id}
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}>
                                    {row.label}
                                    </TableSortLabel></span>
                                </Tooltip>
                            }
                        </TableCell>
                    );
                }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

export default EnhancedTableHead;
